import { render, staticRenderFns } from "./BulkImport.vue?vue&type=template&id=644067d3&scoped=true&"
import script from "./BulkImport.vue?vue&type=script&lang=js&"
export * from "./BulkImport.vue?vue&type=script&lang=js&"
import style0 from "./BulkImport.vue?vue&type=style&index=0&id=644067d3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644067d3",
  null
  
)

export default component.exports